import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { fetchJson, getErrorMessage } from '../lib/api';

export default function ConectarTienda() {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleConnect = async () => {
    setLoading(true);
    setError('');

    try {
      const data = await fetchJson('/tiendanube/oauth/connect-url', {
        method: 'POST',
        body: JSON.stringify({}),
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (data?.authorizeUrl) {
        window.location.assign(data.authorizeUrl);
      } else {
        setError('No se recibió la URL de autorización.');
      }
    } catch (err) {
      setError(getErrorMessage(err?.payload, err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <section className="hero-panel hero-panel--home">
        <div className="hero-copy">
          <p className="eyebrow">Tiendanube</p>
          <h1>Asociá tu tienda</h1>
          <p className="hero-text">
            Tu cuenta de ESA Logística está creada, pero todavía no tenés una tienda de Tiendanube vinculada.
            Hacé clic en el botón para autorizar la app y completar la integración.
          </p>

          {error && (
            <div className="form-error" style={{ marginBottom: '1rem' }}>
              {error}
            </div>
          )}

          <div className="hero-actions">
            <button
              type="button"
              className="landing-action-primary"
              onClick={handleConnect}
              disabled={loading}
            >
              {loading ? 'Cargando...' : 'Conectar con Tiendanube'}
            </button>
          </div>
        </div>

        <div className="hero-side">
          <div className="panel quick-panel">
            <p className="eyebrow">¿Qué pasa al conectar?</p>
            <div className="admin-links">
              <div className="link-card">
                <strong>1. Autorización</strong>
                <span>Tiendanube pide permisos para acceder a tu tienda.</span>
              </div>
              <div className="link-card">
                <strong>2. Callback</strong>
                <span>La app recibe el token y vincula la tienda a tu cliente.</span>
              </div>
              <div className="link-card">
                <strong>3. Portal</strong>
                <span>Ya podés ver pedidos, cotizaciones y operar.</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
